import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import logo from "../../Images/quatroLogo.jpg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faRightFromBracket  } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import "./PageHeader.css"

const PageHeader = () => {

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //RETURN IF NOT LOGGED IN
    if(!sessionUser) {
         //
        window.location.href = "/";
    }


    const logOutAction = () => {

        //CLEAR SESSION
        sessionStorage.clear();

        //
        window.location.href = "/";

    } //END FUNCTION



    return(

        <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
            <Row >
                
                <Col md={9} xs={4} style={{textAlign: "left", paddingLeft:"0px", paddingTop:"10px"}}>
                    <img src={logo} alt="Logo" style={{ width: "130px"}}/>
                    <br />

                </Col>

                <Col md={3} xs={8} style={{textAlign: "right", paddingTop:"25px", fontSize: "12px"}}>
                    <Row>
                        <Col xs={10}>
                            <div style={{borderRight:"1px solid black", padding: "5px"}}>
                                <b>Usuario:</b> {sessionUser.customer_name} <br /> 
                                <b>Grupo:</b> {sessionUser.groupname} <br/>
                            </div>
                        </Col>
                        <Col xs={2} style={{paddingTop: "5px", fontSize:"24px", color: "darkred", textAlign:"left"}}>
                            <FontAwesomeIcon icon={faRightFromBracket} onClick={logOutAction}  style={{cursor:"pointer"}} />
                        </Col>
                    </Row>
                </Col>
               
                <Col xs={12} style={{backgroundColor: "#404661", color: "white", height:"40px", marginTop:"7px", fontSize: "13px"}}>
                    <Row style={{paddingTop: "10px"}}>
                    <Col md={3} xs={6} style={{textAlign:"center", borderRight: "1px solid #AAAAAA"}}>
                        <Link to="/orderListing" className={window.location.href.includes("order") === true ? "linkActivate" : "linkNoActivate"}>
                            Listado de Ordenes
                        </Link>
                    </Col> 

                    { sessionUser.groupname === "Administrativos" ? (
                        <Col md={3} xs={6} style={{textAlign:"center", borderRight: "1px solid #AAAAAA"}}>
                            <Link to="/usersCrud" className={window.location.href.includes("users") === true ? "linkActivate" : "linkNoActivate"}>Gestión de Usuarios</Link>
                        </Col> 
                    ) : "" }

                    </Row>
                </Col>
            </Row>
            
            <hr />

        </div>


    );



}

export default PageHeader;